import service from './service';

export const getPointsOfInterestList = async () => {
  const response = await service.getPublic('/interest/list');

  if (response.status === 200) {
    const data = response.data;
    return data;
  }
};
